// This script handles the tab functionality for the size guide table
function toggleGuide(guideId) {
  const guideButtons = document.querySelectorAll('.tab-guide');
  const tableContents = document.querySelectorAll('.table-content');

  const guideButton = document.getElementById(`${guideId}-guide`);
  const guideContent = document.getElementById(`${guideId}-content`);

  // Remove active class from all buttons and hide all content
  guideButtons.forEach((btn) => {
    btn.classList.remove('active-guide');
  });

  tableContents.forEach((content) => {
    content.style.display = 'none';
    content.classList.remove('table-active');
  });

  // Add active class to the clicked button
  guideButton.classList.add('active-guide');

  // Show the corresponding content
  guideContent.style.display = 'block';
  guideContent.classList.add('table-active');
}

// This script handles the tab functionality for the size guide table
function toggleMobileGuide(guideId) {
  const guideButtons = document.querySelectorAll('.mobile-tab-guide');
  const tableContents = document.querySelectorAll('.mobile-table-content');

  const guideButton = document.getElementById(`${guideId}-mobile-guide`);
  const guideContent = document.getElementById(`${guideId}-mobile-content`);

  // Remove active class from all buttons and hide all content
  guideButtons.forEach((btn) => {
    btn.classList.remove('active-guide');
  });

  tableContents.forEach((content) => {
    content.style.display = 'none';
    content.classList.remove('table-active');
  });

  // Add active class to the clicked button
  guideButton.classList.add('active-guide');

  // Show the corresponding content
  guideContent.style.display = 'block';
  guideContent.classList.add('table-active');
}
